import { createApp } from '@o-din/app';

import Maintenance from '@o-din-maintenance/src/o-din-maintenance';
import Ppr from '@o-din-ppr/src/o-din-ppr';
import Report from '@o-din-report/src/o-din-report';

createApp('#app', [Maintenance, Report, Ppr]);
